import {Component, Input, ChangeDetectionStrategy} from '@angular/core';
import { NgClass } from "@angular/common";
import {Scoreboard} from "../../core/models/models";
import {AuthenticationService} from "../../services/authentication.service";

@Component({
  selector: 'app-score-table',
  standalone: true,
  imports: [
    NgClass
],
  templateUrl: './score-table.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './score-table.component.scss'
})
export class ScoreTableComponent {
  @Input()
  scoreboard: Scoreboard | undefined;

  @Input()
  markWinner: boolean = false;

  constructor(private authenticationService: AuthenticationService) {
  }

  isLoggedInUser(user_id: string) {
    const loggedInUserId = this.authenticationService.getUser()?.user_id;
    return loggedInUserId == user_id;
  }
}
